if(!customElements.get('minicart-popup')) {
  class ComponentMinicartPopup extends HTMLElement {
    constructor() {
      super();
      if ( sessionStorage.getItem('bedjet_minicart_seen') !== 'true' && !this.dataset.template.includes('cart') && !this.dataset.template.includes('checkout')) {
        this.popup = this.querySelector('.minicart-popup-container');
        $s.openModal(this.popup, 'minicart-popup-modal');
        sessionStorage.setItem('bedjet_minicart_seen', true);
      }
    }



  }
  customElements.define('minicart-popup', ComponentMinicartPopup);
}